<mat-card>
  <img mat-card-image [src]="data.IMAGE_MEASURE" alt="img">
  <div>
    <div *ngIf="data.IS_MULTI_INFORMANT === 0">
      <img *ngIf="data.MEASURE_DONE || researchMeasureStatus" src="../../../../assets/check_white_circle.png" width="30px"
        style="position: absolute; top: 15px; left: 15px; border-radius: 30px; box-shadow: 0px 0px 5px #7e7e7edb;"
        alt="done">
    </div>
      <div *ngIf="data.IS_MULTI_INFORMANT === 1 && data.IS_TRAGET === 1">
        <img *ngIf="data.COMPLETED === 1" src="../../../../assets/check_white_circle.png" width="30px"
        style="position: absolute; top: 15px; left: 15px; border-radius: 30px; box-shadow: 0px 0px 5px #7e7e7edb;"
        alt="done">
      </div>

    <div *ngIf="data.IS_MULTI_INFORMANT === 1 && data.IS_TRAGET === 1">
      <div class="informant-icon" (click)="informant()">
        <img *ngIf="data.COMPLETED === 1" src="../../../../assets/informant-green.png" alt="share">
        <img *ngIf="data.COMPLETED === 0" src="../../../../assets/informant-red.png" alt="share">
      </div>
    </div>
    <img *ngIf="!type" src="../../../../assets/share_white_circle.png" width="30px" alt="share"
      style="position: absolute; top: 15px; right: 15px; cursor: pointer; border-radius: 30px; box-shadow: 0px 0px 5px #7e7e7edb;"
      (click)="share()">
  </div>

  <mat-card-content>
    <h4 class="text-center cut-text">{{ data.MEASURE_NAME }}</h4>
  </mat-card-content>

  <mat-card-footer class="text-center" style="width: 80%; margin: 0 auto;">
    <p *ngIf="!type" class="text-left text-primary" style="margin: 5px 0;">ประเภท {{ data.MEASURE_TYPE }}</p>

    <button *ngIf="!type" class="btn rounded mt-3"
      style="background-color: #060E9F; color: #FFF; width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
      (click)="openDetail(data.LINK)">
      ทำแบบทดสอบ
      <img src="assets/edit-w.png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
    </button>

    <div *ngIf="type === 'research'">

      <button *ngIf="statusButton && !researchMeasureStatus" class="btn rounded mt-3"
        style="background-color: #060E9F; color: #FFF; width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
        (click)="colloectAccessLink(data.LINK)">
        ทำแบบทดสอบ
        <img src="assets/edit-w.png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
      </button>

      <button *ngIf="researchMeasureStatus" class="btn btn-success text-center mt-3"
        style="width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;" disabled>
        <img src="assets/check (white).png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
        ทำแบบทดสอบแล้ว
      </button>

      <div *ngIf="!statusButton && !researchMeasureStatus">
        <p *ngIf="curdate < mStartDate" class="text-danger text-center mt-3">
          ยังไม่ถึงเวลาทำแบบทดสอบ
        </p>
        <p *ngIf="curdate > mEndDate" class="text-danger text-center mt-3">
          หมดเวลาทำแบบทดสอบ
        </p>
      </div>
    </div>

    <!-- normal -->
    <div *ngIf="data.IS_MULTI_INFORMANT === 0">
      <button *ngIf="data.MEASURE_DONE" class="btn btn-success rounded mt-3"
        style="width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
        (click)="report()">
        รายงานแบบทดสอบ
        <img src="assets/document white.png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
      </button>
    </div>

    <!-- informant -->
    <div *ngIf="data.IS_MULTI_INFORMANT === 1 && data.IS_TRAGET === 1">
      <button *ngIf="data.COMPLETED === 1" class="btn btn-success rounded mt-3"
        style="width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
        (click)="report()">
        รายงานแบบทดสอบ
        <img src="assets/document white.png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
      </button>
      <button *ngIf="data.COMPLETED === 0" class="btn btn-success rounded mt-3"
        style="width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
        (click)="informant()">
        รายงานแบบทดสอบ
        <img src="assets/document white.png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
      </button>
    </div>

  </mat-card-footer>
</mat-card>


<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>